import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function UndoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"undo"}/>
}
